import { Box, SxProps } from '@mui/material';

type LogoWhiteProps = {
  sx?: SxProps;
  variant?: 'primary' | 'white';
  icon?: boolean;
  text?: 'right' | 'bottom';
  scale?: number;
  gap?: number | string;
};

const SwishLogo = (props: LogoWhiteProps) => {
  const { variant = 'primary', scale = 8 } = props;
  const isWhite = variant === 'white';
  const sx = {
    root: {
      display: 'inline-flex',
      flexDirection: ['right'].includes(props.text) ? 'row' : 'column',
      justifyContent: 'center',
      alignItems: ['bottom'].includes(props.text) ? 'start' : 'center',
      gap: props.gap || 0.5,
      width: `${scale * 8}px`,
      height: `${scale * 4}px`,
      ...(isWhite
        ? {
            '& path[fill="#0096D4"]': { fill: '#fff' },
          }
        : {}),
    },
    icon: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      borderRadius: '8px',
    },
    text: {
      height: `${scale * 1}px`,
      ml: ['bottom'].includes(props.text) ? 2 : 0,
    },
  };

  return (
    <Box sx={[sx.root, ...(Array.isArray(props.sx) ? props.sx : [props.sx])]}>
      <svg
        width={`${scale * 8}px`}
        height={`${scale * 4}px`}
        viewBox="0 0 132 50"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M60.1658 34.8155L66.1555 34.329V32.7307L60.1658 33.1477V34.8155Z"
          fill="#F59C00"
        />
        <path
          d="M12.8705 38.5679L18.7825 38.151V36.4832L12.8705 36.9696V38.5679Z"
          fill="#F59C00"
        />
        <path
          d="M125.197 28.0746V29.6729L131.187 29.256V27.5881L125.197 28.0746Z"
          fill="#F59C00"
        />
        <path
          d="M111.973 30.7154L117.885 30.2984V28.6306L111.973 29.1171V30.7154Z"
          fill="#F59C00"
        />
        <path
          d="M22.5941 37.8034L28.5838 37.317V35.6492L22.5941 36.1356V37.8034Z"
          fill="#F59C00"
        />
        <path
          d="M48.1865 35.7881L54.0984 35.3017V33.7034L48.1865 34.1203V35.7881Z"
          fill="#F59C00"
        />
        <path
          d="M35.4293 35.163V36.7613L41.3412 36.3443V34.6765L35.4293 35.163Z"
          fill="#F59C00"
        />
        <path
          d="M60.1659 33.1478L66.1556 32.7308V5.55933L60.1659 6.04577V33.1478Z"
          fill="#0096D4"
        />
        <path
          d="M60.1659 45.7952L66.1556 45.3088V35.9968L60.1659 36.4833V45.7952Z"
          fill="#0096D4"
        />
        <path
          d="M12.8705 42.3901C12.8705 43.919 12.0926 44.7529 10.5368 44.8919L9.44776 44.9614C7.65862 45.1004 6.80295 44.4054 6.80295 42.8766V40.7223L0.813232 41.2088V43.2241C0.813232 48.0885 3.22468 50.3123 7.96978 49.9648L11.6258 49.6868C16.4487 49.3394 18.7824 46.9072 18.7824 42.4596V39.8884L12.8705 40.2359V42.3901Z"
          fill="#0096D4"
        />
        <path
          d="M11.6258 9.86763L7.89199 10.1456C3.22468 10.5625 0.813232 12.9948 0.813232 17.5118V25.6424C0.813232 26.6848 0.968809 27.5187 1.20218 28.1441C1.43554 28.7695 1.82448 29.256 2.44679 29.6034C2.99131 29.9509 3.92477 30.3679 5.16939 30.8543L10.7702 33.217C11.548 33.5645 12.0148 33.8425 12.4037 34.1204C12.7149 34.3289 12.8705 34.8154 12.8705 35.5798V36.9001L18.7824 36.4137V33.8425C18.7824 32.4526 18.6268 31.4797 18.3156 30.9933C18.0045 30.5068 17.6156 30.1594 17.071 29.8119C16.5265 29.5339 15.6708 29.0475 14.4262 28.5611L8.74766 26.2678C7.96978 25.9203 7.50305 25.6424 7.1141 25.3644C6.80295 25.1559 6.64737 24.6695 6.64737 23.9051V17.3033C6.64737 15.705 7.50305 14.8711 9.21439 14.7321L10.1479 14.6626C11.8592 14.5236 12.7149 15.288 12.7149 16.8169V20.2915L18.6268 19.805V15.9135C18.7824 11.6049 16.3709 9.52017 11.6258 9.86763Z"
          fill="#0096D4"
        />
        <path
          d="M125.197 38.1512V38.7766V40.6529L131.187 40.1665V30.8545L125.197 31.3409V38.1512Z"
          fill="#0096D4"
        />
        <path
          d="M124.03 10.9102L119.052 11.3271C118.663 11.3271 118.274 11.3966 117.885 11.4661V1.45923L111.973 1.94567V18.6933V29.1172L117.885 28.6307V23.2103V18.5543C117.885 17.0255 118.741 16.1916 120.452 16.0526L122.552 15.9136C124.264 15.7746 125.119 16.4696 125.119 18.0679V28.1443L131.031 27.6578V17.234C131.187 12.6475 128.775 10.5627 124.03 10.9102Z"
          fill="#0096D4"
        />
        <path
          d="M111.973 41.6951L117.885 41.2087V39.3324V38.707V31.8967L111.973 32.3832V41.6951Z"
          fill="#0096D4"
        />
        <path
          d="M28.5838 27.9357V23.0713V8.54736L22.5941 8.96432V36.1358L28.5838 35.6494V27.9357Z"
          fill="#0096D4"
        />
        <path
          d="M48.1865 21.5423V26.3373V34.1204L54.0984 33.7035V6.53198L48.1865 7.01843V21.5423Z"
          fill="#0096D4"
        />
        <path
          d="M48.1865 39.6105C48.1865 41.1393 47.3309 41.9733 45.6195 42.1122L43.986 42.2512C42.2746 42.3902 41.4189 41.6953 41.4189 40.097V37.9427L35.507 38.4292V40.5834C35.507 42.1122 34.6513 42.9461 32.94 43.0851L31.1509 43.2241C29.4395 43.3631 28.5838 42.6682 28.5838 41.0699V38.9156L22.5941 39.4715V41.9733C22.5941 46.4903 25.0056 48.575 29.7507 48.2276L34.1846 47.8801C35.896 47.7411 37.2184 47.3242 38.3074 46.6987C39.3964 47.1852 40.7966 47.3937 42.4302 47.2547L46.8641 46.9072C51.6092 46.5597 54.0207 44.058 54.0207 39.541V37.0393L48.1865 37.4563V39.6105Z"
          fill="#0096D4"
        />
        <path
          d="M41.3412 34.6766V26.8935V22.0985V7.50513L35.4293 7.99157V22.585V27.3799V35.1631L41.3412 34.6766Z"
          fill="#0096D4"
        />
        <path
          d="M77.1239 24.5308L93.8485 33.9122C94.3152 34.1902 94.8597 34.2597 95.4042 34.2597C96.2599 34.1902 97.0378 33.7733 97.5823 33.0783C98.438 31.897 98.2046 30.4376 96.96 29.7427L80.2355 20.3612C77.2017 18.6934 76.9684 15.7748 77.6685 13.69C78.4463 11.5357 80.5466 9.17298 84.2027 8.89501L96.1043 7.99161L94.7819 11.3967C97.7379 8.89501 102.483 6.3238 106.295 4.79497C102.483 3.82208 97.7379 2.01528 94.7819 0L96.1043 3.19665L84.2805 4.10005C78.8353 4.517 74.2458 7.85263 72.6122 12.6476C70.9009 17.3731 72.69 22.0986 77.1239 24.5308Z"
          fill="#0096D4"
        />
        <path
          d="M101.238 22.5154L84.5136 13.1339C83.269 12.439 81.6354 12.856 80.7797 13.9678C79.9241 15.1492 80.1574 16.6085 81.402 17.3035L98.1266 26.6849C101.16 28.3527 101.394 31.2714 100.694 33.3562C99.9157 35.5104 97.8154 37.8732 94.0816 38.1512L79.4573 39.263L80.7797 35.8579C77.9016 38.4291 73.1565 40.9308 69.267 42.5292C73.0787 43.5021 77.8238 45.3089 80.7797 47.3241L79.4573 44.1275L94.0816 43.0156C99.5268 42.5987 104.116 39.263 105.75 34.4681C107.461 29.6731 105.672 25.0171 101.238 22.5154Z"
          fill="#F59C00"
        />
      </svg>
    </Box>
  );
};

export default SwishLogo;
